// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
// LGPD consent state (#511) — imported first so `window.__consent` is populated
// synchronously from the cookie BEFORE the tracking pixel module (#513) runs.
import "./consent"
// Third-party pixel loader (#513) — gated on the public-layout meta tag (prod)
// AND analytics consent; reads `window.__consent` set just above.
import "./analytics_pixel"
import "./controllers"
import "./confirm_dialog"

import "trix"
import "@rails/actiontext"

// Active Storage Direct Upload: browser → S3 sem passar pelo Rails.
// Resolve risco de OOM com uploads grandes concorrentes E elimina false-positive
// do WAF CrossSiteScripting_BODY (que escaneava bytes binários no body multipart).
// O input com data-direct-upload-url ativa o flow.
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
